<template>
  <div class="home">
    <a-row :gutter="16">
      <a-col v-for="problem in problems" :key="problem.key" :span="6" :style="{ marginBottom: '16px' }">
        <a-card :style="{ textAlign: 'center' }" hoverable @click="handleSelect(problem.key)">
          <p class="help-icon">
            <a-icon :type="problem.icon"/>
          </p>
          <template slot="actions" class="ant-card-actions">
            <span><a-icon type="read"/> Dowiedz się więcej</span>
          </template>
          <a-card-meta :title="problem.title">
            <template #description>
              <p class="text-short">
                {{ problem.description }}
              </p>
            </template>
          </a-card-meta>
        </a-card>
      </a-col>
    </a-row>

    <a-drawer :closable="true" :height="'auto'" :placement="'top'" :visible="isProblemDialog"
              @close="isProblemDialog = false">
      <a-row v-if="selectedProblem !== null" :gutter="16" :style="{
        width: '100%',
        maxWidth: '1980px',
        maxHeight: '90vh',
        overflowY: 'auto',
        margin: '64px auto 64px auto',
      }">
        <a-col v-if="selectedProblem !== null" :span="8" style="text-align: center">
          <p class="help-icon">
            <a-icon :type="selectedProblem.icon"/>
          </p>
          <h3 style="font-weight: bold">{{ selectedProblem.title }}</h3>
          <p>
            <span class="text-muted">{{ selectedProblem.description }}</span>
          </p>
        </a-col>
        <a-col :span="16" style="overflow-y: auto">
          <a-collapse v-if="selectedProblem.questions.length !== 0" accordion>
            <template #expandIcon="props">
              <a-icon :rotate="props.isActive ? 90 : 0" type="caret-right"/>
            </template>
            <a-collapse-panel v-for="question in selectedProblem.questions" :key="question.question"
                              :header="question.question">
              <vue-markdown class="wrap-text">{{ question.answer }}</vue-markdown>
            </a-collapse-panel>
          </a-collapse>
        </a-col>
        <a-col :span="24" style="text-align: center; margin-top: 2em">
          <a-button type="primary" @click="isProblemDialog = false">Zamknij</a-button>
        </a-col>
      </a-row>
    </a-drawer>
  </div>
</template>

<script>
import VueMarkdown from "vue-markdown";

export default {
  name: "Help",
  components: {
    "vue-markdown": VueMarkdown,
  },
  data() {
    return {
      isProblemDialog: false,
      selectedProblem: null,
      problems: [
        {
          key: "laptop",
          icon: "laptop",
          title: "Laptop",
          description: "Jak podłączyć laptopa do sieci akademickiej?",
          questions: [
            {
              question:
                  "Co zrobić jeśli nie posiadam gniazda Ethernet w swoim laptopie?",
              answer:
                  "Jeśli nie posiadasz gniazda Ethernet w swoim laptopie to możesz skorzystać z przejściówki pozwalającej podłączyć kabel Ethernet do gniazda USB. Dostępna jest w sklepach z elektroniką. Należy mieć na uwadze to, że każdorazowe wpięcie urządzenia w inny port USB niż podczas rejestracji urządzenia w sieci, może skutkować brakiem dostępu do Internetu.\nDrugą opcją jest zakup routera, który pozwoli na podłączenie wielu urządzeń do sieci poprzez udostępnienie sieci bezprzewodowej. Należy jednak wcześniej zapoznać się z tekstem pomocy dotyczącym sieci Wi-Fi dostępnym na tej stronie!",
            },
            {
              question:
                  "Pomimo wpięcia kabla komputer nie łączy się do sieci, co mogę zrobić?",
              answer:
                  "W celu rozwiązania problemu z brakiem połączenia z siecią, możesz wykonać następujące kroki:\n - Sprawdź kabel sieciowy: Upewnij się, że kabel sieciowy jest dobrze wpięty w gniazdo na twoim komputerze oraz w gniazdo łączące z siecią (router lub gniazdko na ścianie). Jeśli masz dostępny inny kabel, sprawdź, czy z nim działa połączenie.\n - Uruchom ponownie komputer i urządzenie sieciowe: Wyłącz i włącz ponownie komputer oraz urządzenie sieciowe, takie jak router. Czasami problem z połączeniem wynika z tymczasowych błędów, które można rozwiązać przez ponowne uruchomienie urządzeń.\n - Sprawdź ustawienia karty sieciowej: Otwórz Menedżer urządzeń (Device Manager) na swoim komputerze i sprawdź, czy karta sieciowa jest wykrywana i nie ma żadnych problemów z jej działaniem. Jeśli jest wyłączona, włącz ją, a jeśli ma problemy, spróbuj zaktualizować sterowniki.\n - Diagnozuj problem: W systemie Windows możesz użyć narzędzia rozwiązywania problemów z siecią, aby zdiagnozować i naprawić potencjalne problemy z połączeniem. Wyszukaj \"rozwiązywanie problemów z siecią\" (Network Troubleshooter) w pasku wyszukiwania na pasku zadań, a następnie uruchom narzędzie i postępuj zgodnie z wyświetlanymi instrukcjami.\n - Sprawdź inne urządzenia: Upewnij się, że inne urządzenia w twojej sieci mogą nawiązać połączenie z Internetem. Jeśli wszystkie urządzenia mają problem z połączeniem, problem może być po stronie dostawcy lub urządzenia sieciowego (router).\n- Skontaktuj się z administratorem sieci: Jeśli żadne z powyższych kroków nie pomogło w rozwiązaniu problemu, skontaktuj się z administratorem sieci. Oni mogą sprawdzić, czy problem nie leży po ich stronie, np. awaria sprzętu czy prace serwisowe. W razie potrzeby mogą również udzielić dalszych wskazówek dotyczących rozwiązania problemu z połączeniem sieciowym.\n\nPamiętaj, że w przypadku laptopów z kartami sieciowymi Wi-Fi, warto również sprawdzić, czy przypadkiem nie został włączony tryb samolotowy, który wyłącza połączenia sieciowe.",
            },
          ],
        },
        {
          key: "wifi",
          icon: "wifi",
          title: "Wi-Fi",
          description: "Wszystko co musisz wiedzieć o swojej sieci Wi-Fi.",
          questions: [
            {
              question: "Jaki router zakupić?",
              answer:
                  'Nasza sieć wspiera tylko i wyłącznie routery DSL. Nie pomyl z routerami ADSL (tak zwanymi "telefonicznymi" lub "na łącze telefoniczne")! To bardzo ważne, ponieważ routery ADSL nie współpracują z siecią akademicką!',
            },
            {
              question:
                  "Posiadam konto Eduroam, czy mogę korzystać z sieci w domu studenckim?",
              answer:
                  "Tak, jeśli sieć Eduroam jest dostępna w danym domu studenckim, możesz korzystać z niej, używając swojego konta Eduroam. Eduroam to globalna usługa sieci Wi-Fi przeznaczona dla społeczności akademickiej, która umożliwia użytkownikom korzystanie z bezprzewodowego dostępu do Internetu na terenie uczelni, a także w niektórych domach studenckich i innych instytucjach naukowych.\nJednak warto pamiętać, że nie każdy akademik udostępnia taką możliwość. Aby uzyskać więcej informacji na temat dostępności sieci Eduroam w Twoim domu studenckim, zalecamy odwiedzenie strony student.tu.kielce.pl.\n\nSieć Eduroam jest niezależna od sieci kablowej, nie należy ich łączyć w żaden sposób ze sobą.",
            },
            {
              question:
                  "Jak mogę skonfigurować router, aby działał w sieci akademickiej?",
              answer:
                  "Podstawowa konfiguracja routera zgodnie z instrukcją zawartą w opakowaniu jest zazwyczaj wystarczająca, aby działał w sieci akademickiej. Oto kilka kroków, które możesz wykonać, aby skonfigurować router:\n1. Podłącz router do gniazdka sieciowego na ścianie za pomocą kabla Ethernet (WAN) - to połączenie umożliwi routerowi uzyskanie dostępu do Internetu.\n2. Podłącz zasilacz routera do gniazdka elektrycznego i włącz urządzenie.\n3. Połącz się z siecią Wi-Fi generowaną przez router za pomocą komputera lub innego urządzenia. Zazwyczaj nazwa sieci (SSID) i hasło są wydrukowane na etykiecie umieszczonej na obudowie routera.\n4. Zaloguj się do panelu administracyjnego routera, wpisując adres IP routera (zwykle 192.168.0.1 lub 192.168.1.1) w pasku adresu przeglądarki. Następnie wprowadź login i hasło do panelu (zwykle \"admin\" i \"admin\" lub \"password\").\n5. W panelu administracyjnym routera możesz zmienić ustawienia sieci Wi-Fi, takie jak nazwa sieci (SSID) i hasło.\n6. W ustawieniach sieci WAN należy skorzystać z opcji \"dynamicznego adres IP\"!\n\nNastępnie dodaj urządzenie do swojego profilu poprzez panel użytkownika na stronie domu studenckiego (panel dostępny tylko z sieci akademickiej). Jeśli strona domu studenckiego dalej nie jest dostępna przez Wi-Fi routera lub nie da się dodać urządzenia do profilu, skontaktuj się z administratorem sieci akademickiej i natychmiast odłącz urządzenie od zasilania.\nMiej na uwadze, że niektóre akademiki mogą mieć specyficzne wymagania dotyczące konfiguracji routera. W takim przypadku warto skonsultować się z administratorem sieci akademickiej lub sprawdzić na stronie domu studenckiego, czy są dostępne dodatkowe instrukcje.",
            },
          ],
        },
        {
          key: "form",
          icon: "file-done",
          title: "Wniosek",
          description: "Pytania odnośnie wniosku i jego szczegółów.",
          questions: [
            {
              question: "Zarejestrowałam(em) nie moje urządzenie na moim koncie, czy to problem?",
              answer:
                  "Każde urządzenie powinno być zarejestrowane na koncie właściciela. Prosimy o zgłoszenie takiego przypadku, ponieważ w przypadku problemów z prawem osobą odpowiedzialną za to urządzenie jest osoba, która zarejestrowała urządzenie na swoim koncie.",
            },
            {
              question: "Oddałam(em) lub sprzedałam(em) urządzenie komuś innemu, co wtedy?",
              answer:
                  "Każde urządzenie powinno być zarejestrowane na koncie aktualnego właściciela. Prosimy o zgłoszenie takiego przypadku, ponieważ w przypadku problemów z prawem osobą odpowiedzialną za to urządzenie jest osoba, która zarejestrowała urządzenie na swoim koncie.",
            },
            {
              question: "Otrzymałam(em) lub kupiłam(em) urządzenie od kogoś innego, co wtedy?",
              answer:
                  "Każde urządzenie powinno być zarejestrowane na koncie aktualnego właściciela. Prosimy o zgłoszenie takiego przypadku, ponieważ w przypadku problemów z prawem osobą odpowiedzialną za to urządzenie jest osoba, która zarejestrowała urządzenie na swoim koncie.",
            },
            {
              question: "Nie posiadam numeru PESEL, co zrobić?",
              answer:
                  "Jeśli nie posiadasz nadanego numeru PESEL to możesz uzupełnić pole numerem paszportu lub numerem karty pobytu. Żadne inne dane identyfikacyjne nie są uznawane.",
            },
            {
              question:
                  'Czy wpisać w pole "Numer PESEL/Paszport" obie wartości jeśli posiadam numer PESEL i paszport?',
              answer:
                  "Nie! Uzupełnij tylko numer PESEL. Numer paszportu jest wtedy zbędny.",
            },
            {
              question:
                  "Nie jestem studentką/studentem uczelni wyższej, jak mam uzupełnić dane o uczelni?",
              answer:
                  "Jeśli nie jesteś studentką/studentem uczelni wyższej to możesz pominąć pola z danymi studenta.",
            },
          ],
        },
        // {
        //   key: "access",
        //   icon: "global",
        //   title: "Dostęp do Internetu",
        //   description:
        //     "Zasady korzystania z sieci akademickiej i pomoc w działaniu.",
        //   questions: [
        //     {
        //       question: "",
        //       answer: "",
        //     },
        //   ],
        // },
        {
          key: "desktop",
          icon: "desktop",
          title: "Komputer stacjonarny",
          description: "Jak podłączyć komputer stacjonarny do sieci?",
          questions: [
            {
              question: "",
              answer: "",
            },
          ],
        },
        {
          key: "printer",
          icon: "printer",
          title: "Drukowanie wniosku",
          description: "Jak wydrukować wniosek kiedy nie posiada się drukarki?",
          questions: [
            {
              question:
                  "Gdzie mogę wydrukować wygenerowany wniosek o dostęp do sieci?",
              answer:
                  "Wydruk możliwy jest do zrealizowania w punktach ksero dostępnych na osiedlu oraz poza nim.",
            },
          ],
        },
        {
          key: "pricing",
          icon: "euro",
          title: "Opłaty",
          description: "Dostęp do sieci jest darmowy! Nie daj się oszukać!",
          questions: [
            {
              question: "Czy dostęp do sieci jest darmowy?",
              answer:
                  "Tak, dostęp do sieci akademickiej jest w pełni darmowy do celów prywatnych dla mieszkańców osiedla akademickiego.",
            },
            {
              question: "Wykorzystanie sieci do celów komercyjnych",
              answer:
                  "W przypadku planowania wykorzystania sieci akademickiej do celów komercyjnych, należy skontaktować się z zarządem domu studenckiego lub uczelni, aby omówić szczegóły i ewentualne warunki takiego wykorzystania.",
            },
          ],
        },
        {
          key: "mobile",
          icon: "mobile",
          title: "Dostęp z telefonu",
          description:
              "Jak skonfigurować dostęp do Internetu z poziomu telefonu?",
          questions: [
            {
              question: "Czy mogę korzystać z sieci akademickiej z telefonu?",
              answer:
                  'Tak, jednak należy zadbać o własną sieć Wi-Fi. Można w tym celu wykorzystać wbudowane opcje systemu operacyjnego na swoim komputerze (jeśli posiada opcję hotspotu) lub poprzez własny router DSL. \nWięcej na ten temat znajduje się w zakładce "Pomoc" → "Wi-Fi".',
            },
          ],
        },
        {
          key: "service",
          icon: "customer-service",
          title: "Inna pomoc",
          description: "Pomoc z problemami z komputerem",
          questions: [
            {
              question: "Zarejestrowałam(em) nie moje urządzenie na moim koncie, czy to problem?",
              answer:
                  "Każde urządzenie powinno być zarejestrowane na koncie właściciela. Prosimy o zgłoszenie takiego przypadku, ponieważ w przypadku problemów z prawem osobą odpowiedzialną za to urządzenie jest osoba, która zarejestrowała urządzenie na swoim koncie.",
            },
            {
              question: "Oddałam(em) lub sprzedałam(em) urządzenie komuś innemu, co wtedy?",
              answer:
                  "Każde urządzenie powinno być zarejestrowane na koncie aktualnego właściciela. Prosimy o zgłoszenie takiego przypadku, ponieważ w przypadku problemów z prawem osobą odpowiedzialną za to urządzenie jest osoba, która zarejestrowała urządzenie na swoim koncie.",
            },
            {
              question: "Otrzymałam(em) lub kupiłam(em) urządzenie od kogoś innego, co wtedy?",
              answer:
                  "Każde urządzenie powinno być zarejestrowane na koncie aktualnego właściciela. Prosimy o zgłoszenie takiego przypadku, ponieważ w przypadku problemów z prawem osobą odpowiedzialną za to urządzenie jest osoba, która zarejestrowała urządzenie na swoim koncie.",
            },
            {
              question:
                  "Czy mogę uzyskać pomoc w przypadku problemów z komputerem?",
              answer:
                  "Nie. Sprzętem powinna zająć się wykwalifikowana osoba w odpowiednim serwisie komputerowym.",
            },
            {
              question:
                  "Czy mogę uzyskać pomoc w przypadku problemów z routerem?",
              answer:
                  "Każdy problem jest indywidualny więc prosimy o kontakt, postaramy się pomóc w podłączeniu urządzenia do sieci akademickiej.",
            },
            {
              question: "Czy serwisujecie sprzęt sieciowy?",
              answer:
                  "Nie. Sprzętem powinna zająć się wykwalifikowana osoba w odpowiednim serwisie komputerowym.",
            },
          ],
        },
      ],
    };
  },
  mounted() {
    this.$emit("loadedView");
  },
  methods: {
    handleSelect: function (page) {
      console.log("Selected: ", page);
      this.selectedProblem = this.problems.find(
          (problem) => problem.key === page
      );
      this.isProblemDialog = true;
    },
  },
};
</script>

<style scoped>
.help-icon {
  text-align: center;
  font-size: 5em;
  margin-bottom: 16px;
}

.text-short {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.wrap-text {
  white-space: pre-wrap;
}
</style>
